let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bPovI")).then(() => parcelRequire('5CRaU'));